//IE
var ua = navigator.userAgent.toLowerCase();
var ver = navigator.appVersion.toLowerCase();
// IE(11以外)
var isMSIE = (ua.indexOf('msie') > -1) && (ua.indexOf('opera') == -1);
// IE11
var isIE11 = (ua.indexOf('trident/7') > -1);
// Edge
var isEdge = (ua.indexOf('edge') > -1);
// IE
var isIEnotEdge = isMSIE || isIE11;
var isAllIE = isMSIE || isIE11 || isEdge;
if(isIEnotEdge) {
  $("body").addClass('ieStyle')
} else if(isEdge) {
  $("body").addClass('edgeStyle')
}

// //INVIEW
$('.js-inview').on('inview', function(event, isInView) {
	if(isInView){
		$(this).stop().addClass('animation');
	}
});

//nav追随
const fix_items = $('#local_navi_wrap');
const sec2H = $('#local_nav_anchor').offset().top;

$(window).on("scroll",function() {
  if ($(this).scrollTop() > sec2H) {
    //ボタンの表示方法
    fix_items.addClass('fix');
  } else {
    //ボタンの非表示方法
    fix_items.removeClass('fix');
  }
});

//シェアトコ
var url1 = 'https://tagplus.biz/meiji_bulgariayogurt/api/medias?hashtag=%E3%82%84%E3%82%8F%E3%82%89%E3%81%8B%E3%82%B8%E3%83%A5%E3%83%BC%E3%82%B7%E3%83%BC%E3%82%B3%E3%83%BC%E3%82%B9&status=show&editors_choice=all&source=all';
var url2 = 'https://tagplus.biz/meiji_bulgariayogurt/api/medias?hashtag=%E3%81%86%E3%81%BE%E5%91%B3%E3%82%A2%E3%83%83%E3%83%97%E3%82%B3%E3%83%BC%E3%82%B9&status=show&editors_choice=all&source=all';
var url3 = 'https://tagplus.biz/meiji_bulgariayogurt/api/medias?hashtag=%E5%AE%B6%E6%97%8F%E3%81%AE%E7%AC%91%E9%A1%94%E3%82%B3%E3%83%BC%E3%82%B9&status=show&editors_choice=all&source=all';
function snsGet(divId,snsurl){
	$.ajax({ type: "GET",
		dataType: "json",
		url: snsurl,
		success: function(data, json){
			
			var data_number = data.data.length;
			var first_number = 0;
			
			function panelOpen($firstNum,$i){
				for( var i =$firstNum ; i<=$i ; i++ ){
					if(data.data[i]) {
						var h = '<li class="'+data.data[i].source+'"><a href="'
						+ data.data[i].permalink
						+ '" target="_blank" rel="noopener"' 
								+	'style="background: url('+data.data[i].media_url+'); background-size: cover;">'
							+	'</a></li>';
						$("#snslist-"+divId).append(h);
					}
				}
			}
			//初期パネル6枚追加
			panelOpen(0,5);
			$("#snslist-"+divId+"+.js-btn-more").on('click',function(){
 				if(first_number < data_number) {
					//始まりの数
					first_number = first_number + 6;
					//終わりの数
					var last_number = first_number + 5;
					//パネルを追加
					panelOpen(first_number,last_number);
					//最大枚数と同じか1枚でも超えた時にボタンを非表示
					if(last_number+1 >= data_number) {
		 				$("#snslist-"+divId+"+.js-btn-more").hide();
					}
 				}
			});
			//画像読み込み失敗代替画像
			$("#snslist-"+divId+" img").on("error",function(){
				$(this).attr('src', '/pc/special/campaign/lb81-kakurewaza-familycp/data/images/noimg.jpg');
			});
		},
		error: function(data, json){
			$("#snslist-"+divId).append('<li>データの取得に失敗しました。</li>');
		}
	});
}
snsGet("yawaraka",url1);
snsGet("umami",url2);
snsGet("family",url3);

//ハッシュタグ コピー
function clipCopy($inputId) {
  var copytext = document.getElementById($inputId);
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    try {
      copytext.readOnly = false;
      var range = document.createRange();
      range.selectNode(copytext);
      window.getSelection().addRange(range);
      document.execCommand("copy");
      copytext.readOnly = true;
      alert("ハッシュタグをコピーしました。");
    } catch (e) {
      copytext.readOnly = true;
      alert("このブラウザでは対応していません。");
    }
  } else {
    try {
      copytext.select();
      document.execCommand('copy');
      alert("ハッシュタグをコピーしました。");
    } catch (e) {
      alert("このブラウザでは対応していません。");
    }
  }
};

//アコーディオン
$(".rules_box .js-rules_toggle+dd").hide();
$(".rules_box .js-rules_toggle").on("click",function(){
	$(this).toggleClass("on").next("dd").not(":animated").slideToggle(300);
});
